import { render, staticRenderFns } from "./cSwipers.vue?vue&type=template&id=170cd057"
import script from "./cSwipers.vue?vue&type=script&lang=js"
export * from "./cSwipers.vue?vue&type=script&lang=js"
import style0 from "./cSwipers.vue?vue&type=style&index=0&id=170cd057&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports